/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesPlayGameResponseMobileGameOrientation } from './FxIdWebFeaturesPlayGameResponseMobileGameOrientation';
import {
    FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSON,
    FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSON,
    FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseMobileGameOrientation';
import type { FxIdDomainSettingsUrlOpenMethod } from './FxIdDomainSettingsUrlOpenMethod';
import {
    FxIdDomainSettingsUrlOpenMethodFromJSON,
    FxIdDomainSettingsUrlOpenMethodFromJSONTyped,
    FxIdDomainSettingsUrlOpenMethodToJSON,
    FxIdDomainSettingsUrlOpenMethodToJSONTyped,
} from './FxIdDomainSettingsUrlOpenMethod';
import type { FxIdDomainSettingsEGameOrientation } from './FxIdDomainSettingsEGameOrientation';
import {
    FxIdDomainSettingsEGameOrientationFromJSON,
    FxIdDomainSettingsEGameOrientationFromJSONTyped,
    FxIdDomainSettingsEGameOrientationToJSON,
    FxIdDomainSettingsEGameOrientationToJSONTyped,
} from './FxIdDomainSettingsEGameOrientation';
import type { FxIdWebFeaturesPlayGameResponseSupport } from './FxIdWebFeaturesPlayGameResponseSupport';
import {
    FxIdWebFeaturesPlayGameResponseSupportFromJSON,
    FxIdWebFeaturesPlayGameResponseSupportFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseSupportToJSON,
    FxIdWebFeaturesPlayGameResponseSupportToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseSupport';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptions';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptions';
import type { FxIdWebFeaturesPlayGameResponseFxLauncherOptions } from './FxIdWebFeaturesPlayGameResponseFxLauncherOptions';
import {
    FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSON,
    FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSON,
    FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseFxLauncherOptions';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions';
import type { FxIdDomainSettingsPublicWebClientConfigOptions } from './FxIdDomainSettingsPublicWebClientConfigOptions';
import {
    FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsToJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsToJSONTyped,
} from './FxIdDomainSettingsPublicWebClientConfigOptions';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions';
import type { FxIdDomainEntitiesPlayGameType } from './FxIdDomainEntitiesPlayGameType';
import {
    FxIdDomainEntitiesPlayGameTypeFromJSON,
    FxIdDomainEntitiesPlayGameTypeFromJSONTyped,
    FxIdDomainEntitiesPlayGameTypeToJSON,
    FxIdDomainEntitiesPlayGameTypeToJSONTyped,
} from './FxIdDomainEntitiesPlayGameType';
import type { FxIdWebFeaturesPlayGameResponseAuth } from './FxIdWebFeaturesPlayGameResponseAuth';
import {
    FxIdWebFeaturesPlayGameResponseAuthFromJSON,
    FxIdWebFeaturesPlayGameResponseAuthFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseAuthToJSON,
    FxIdWebFeaturesPlayGameResponseAuthToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseAuth';
import type { FxIdWebFeaturesPlayGameResponsePresentation } from './FxIdWebFeaturesPlayGameResponsePresentation';
import {
    FxIdWebFeaturesPlayGameResponsePresentationFromJSON,
    FxIdWebFeaturesPlayGameResponsePresentationFromJSONTyped,
    FxIdWebFeaturesPlayGameResponsePresentationToJSON,
    FxIdWebFeaturesPlayGameResponsePresentationToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponsePresentation';
import type { FxIdWebFeaturesPlayGameResponseStatistics } from './FxIdWebFeaturesPlayGameResponseStatistics';
import {
    FxIdWebFeaturesPlayGameResponseStatisticsFromJSON,
    FxIdWebFeaturesPlayGameResponseStatisticsFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseStatisticsToJSON,
    FxIdWebFeaturesPlayGameResponseStatisticsToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseStatistics';

/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPublicDataBase
 */
export interface FxIdApplicationPublicDataBuilderPublicDataBase {
    /**
     * 
     * @type {FxIdDomainEntitiesPlayGameType}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    PlayGameType: FxIdDomainEntitiesPlayGameType;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptions}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    PlatformData: FxIdApplicationPublicDataBuilderPlatformDataOptions;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseStatistics}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    Statistics?: FxIdWebFeaturesPlayGameResponseStatistics | null;
    /**
     * 
     * @type {FxIdDomainSettingsEGameOrientation}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    GameOrientation: FxIdDomainSettingsEGameOrientation;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseMobileGameOrientation}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     * @deprecated
     */
    MobileGameOrientation: FxIdWebFeaturesPlayGameResponseMobileGameOrientation;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponsePresentation}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    Presentation?: FxIdWebFeaturesPlayGameResponsePresentation | null;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponsePresentation}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    MobilePresentation?: FxIdWebFeaturesPlayGameResponsePresentation | null;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponsePresentation}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    ViewportPresentation?: FxIdWebFeaturesPlayGameResponsePresentation | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    SupportedLanguages: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    DefaultLanguage: string;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseSupport}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    Support?: FxIdWebFeaturesPlayGameResponseSupport | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    Store: FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseFxLauncherOptions}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    FxLauncherOptions?: FxIdWebFeaturesPlayGameResponseFxLauncherOptions | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    Turnstile: FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    CompanyName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    TosUrl: string;
    /**
     * 
     * @type {FxIdDomainSettingsUrlOpenMethod}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    TosUrlOpenMethod: FxIdDomainSettingsUrlOpenMethod;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    PpUrl: string;
    /**
     * 
     * @type {FxIdDomainSettingsUrlOpenMethod}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    PpUrlOpenMethod: FxIdDomainSettingsUrlOpenMethod;
    /**
     * 
     * @type {FxIdDomainSettingsPublicWebClientConfigOptions}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    PublicWebClientConfig: FxIdDomainSettingsPublicWebClientConfigOptions;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseAuth}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    Auth?: FxIdWebFeaturesPlayGameResponseAuth | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    GameSystemName: string;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBase
     */
    NamespacedProductsL10N: boolean;
}



/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBase interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBase(value: object): value is FxIdApplicationPublicDataBuilderPublicDataBase {
    if (!('PlayGameType' in value) || value['PlayGameType'] === undefined) return false;
    if (!('PlatformData' in value) || value['PlatformData'] === undefined) return false;
    if (!('GameOrientation' in value) || value['GameOrientation'] === undefined) return false;
    if (!('MobileGameOrientation' in value) || value['MobileGameOrientation'] === undefined) return false;
    if (!('SupportedLanguages' in value) || value['SupportedLanguages'] === undefined) return false;
    if (!('DefaultLanguage' in value) || value['DefaultLanguage'] === undefined) return false;
    if (!('Store' in value) || value['Store'] === undefined) return false;
    if (!('Turnstile' in value) || value['Turnstile'] === undefined) return false;
    if (!('CompanyName' in value) || value['CompanyName'] === undefined) return false;
    if (!('TosUrl' in value) || value['TosUrl'] === undefined) return false;
    if (!('TosUrlOpenMethod' in value) || value['TosUrlOpenMethod'] === undefined) return false;
    if (!('PpUrl' in value) || value['PpUrl'] === undefined) return false;
    if (!('PpUrlOpenMethod' in value) || value['PpUrlOpenMethod'] === undefined) return false;
    if (!('PublicWebClientConfig' in value) || value['PublicWebClientConfig'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('NamespacedProductsL10N' in value) || value['NamespacedProductsL10N'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBase {
    return FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBase {
    if (json == null) {
        return json;
    }
    return {
        
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeFromJSON(json['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON(json['PlatformData']),
        'Statistics': json['Statistics'] == null ? undefined : FxIdWebFeaturesPlayGameResponseStatisticsFromJSON(json['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationFromJSON(json['GameOrientation']),
        'MobileGameOrientation': FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSON(json['MobileGameOrientation']),
        'Presentation': json['Presentation'] == null ? undefined : FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json['Presentation']),
        'MobilePresentation': json['MobilePresentation'] == null ? undefined : FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json['MobilePresentation']),
        'ViewportPresentation': json['ViewportPresentation'] == null ? undefined : FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json['ViewportPresentation']),
        'SupportedLanguages': json['SupportedLanguages'],
        'DefaultLanguage': json['DefaultLanguage'],
        'Support': json['Support'] == null ? undefined : FxIdWebFeaturesPlayGameResponseSupportFromJSON(json['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON(json['Store']),
        'FxLauncherOptions': json['FxLauncherOptions'] == null ? undefined : FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSON(json['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON(json['Turnstile']),
        'CompanyName': json['CompanyName'],
        'TosUrl': json['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['TosUrlOpenMethod']),
        'PpUrl': json['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON(json['PublicWebClientConfig']),
        'Auth': json['Auth'] == null ? undefined : FxIdWebFeaturesPlayGameResponseAuthFromJSON(json['Auth']),
        'GameSystemName': json['GameSystemName'],
        'NamespacedProductsL10N': json['NamespacedProductsL10N'],
    };
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseToJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBase {
    return FxIdApplicationPublicDataBuilderPublicDataBaseToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeToJSON(value['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON(value['PlatformData']),
        'Statistics': FxIdWebFeaturesPlayGameResponseStatisticsToJSON(value['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationToJSON(value['GameOrientation']),
        'MobileGameOrientation': FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSON(value['MobileGameOrientation']),
        'Presentation': FxIdWebFeaturesPlayGameResponsePresentationToJSON(value['Presentation']),
        'MobilePresentation': FxIdWebFeaturesPlayGameResponsePresentationToJSON(value['MobilePresentation']),
        'ViewportPresentation': FxIdWebFeaturesPlayGameResponsePresentationToJSON(value['ViewportPresentation']),
        'SupportedLanguages': value['SupportedLanguages'],
        'DefaultLanguage': value['DefaultLanguage'],
        'Support': FxIdWebFeaturesPlayGameResponseSupportToJSON(value['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON(value['Store']),
        'FxLauncherOptions': FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSON(value['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON(value['Turnstile']),
        'CompanyName': value['CompanyName'],
        'TosUrl': value['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['TosUrlOpenMethod']),
        'PpUrl': value['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsToJSON(value['PublicWebClientConfig']),
        'Auth': FxIdWebFeaturesPlayGameResponseAuthToJSON(value['Auth']),
        'GameSystemName': value['GameSystemName'],
        'NamespacedProductsL10N': value['NamespacedProductsL10N'],
    };
}

